import React from 'react';
import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';
import { useTranslation } from 'react-i18next';
import { Button } from '@app/core';

const useStyles = createUseStyles((theme: Theme) => ({
  informationBoxContainer: {
    display: 'flex',
    position: 'relative',
    borderRadius: theme.borderRadius.large,
    padding: [
      theme.marginBase * 4,
      theme.marginBase * 28,
      theme.marginBase * 2,
      theme.marginBase * 4,
    ],
    overflow: 'hidden',
    backgroundColor: theme.colors.blueMuted,
    [theme.media.mobile]: {
      padding: [
        theme.marginBase * 3,
        theme.marginBase * 3,
        theme.marginBase,
        theme.marginBase * 3,
      ],
      marginTop: -theme.marginBase * 2,
    },
  },
  informationBoxContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.marginBase * 3,
  },
  illustration: {
    width: 400,
    height: 400,
    position: 'absolute',
    bottom: -200,
    right: -200,
    borderRadius: '50%',
    backgroundColor: theme.colors.blue,
    [theme.media.mobile]: {
      display: 'none',
    },
  },
  btnSignUpContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
  },
  titleInformation: {
    ...theme.fonts.h5,
  },
  description: {
    ...theme.fonts.caption,
  },
}));

export const NotForYouBlock = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classes.informationBoxContainer}>
      <div className={classes.informationBoxContent}>
        <h5 className={classes.titleInformation}>
          {t('publicSession.notForYou.title')}
        </h5>
        <p className={classes.description}>
          {t('publicSession.notForYou.description')}
          <span> &#10084;&#65039;</span>
        </p>
        <div className={classes.btnSignUpContainer}>
          <Button
            text={t('publicSession.notForYou.button')}
            variant="muted"
            small
            rel="noopener noreferrer"
            target="_blank"
            to="/login"
          />
        </div>
      </div>
      <div className={classes.illustration} />
    </div>
  );
};
